export { default } from 'components/NotFound'
